<template>
    <div v-if="isVisible" class="cookies">
        <html-with-links
            tag="p"
            class="cookies__content"
            :html="$t('COOKIES_DESCRIPTION', { learnMoreLink: '/info/privacy' })"
        />
        <div class="cookies__actions">
            <button
                class="cookies__action cookies__action_danger"
                @click="allowNecessaryCookies"
            >
                {{ $t('ALLOW_ONLY_NECESSARY_COOKIES_BUTTON') }}
            </button>
            <button
                class="cookies__action cookies__action_success"
                @click="allowAllCookies"
            >
                {{ $t('ALLOW_ALL_COOKIES_BUTTON') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import HtmlWithLinks from '@/components/HtmlWithLinks';

export default {
  components: {
    HtmlWithLinks,
  },
  computed: {
    ...mapState(['areAllCookiesAllowed']),
    isVisible() {
      return typeof this.areAllCookiesAllowed !== 'boolean';
    },
  },
  methods: {
    ...mapMutations(['setAreAllCookiesAllowed']),
    allowNecessaryCookies() {
      this.setAreAllCookiesAllowed(false);
    },
    allowAllCookies() {
      this.setAreAllCookiesAllowed(true);
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          analytics_storage: 'granted',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.cookies {
    position: fixed;
    width: 350px;
    left: 16px;
    bottom: 16px;
    font-size: 16px;
    z-index: 11000;

    background-color: var(--bg);
    border: 1px solid var(--tertiary-accent);
    box-shadow: 0 0 8px 2px var(--shadow-color);

    @include notebook {
        width: auto;
        left: 8px;
        right: 8px;
        bottom: 8px;
    }

    &__content {
        padding: 16px;
        line-height: 1.2;
    }

    &__actions {
        display: flex;
        border-top: 1px solid var(--tertiary-accent);
    }

    &__action {
        flex: 1 0 0;
        padding: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 16px;

        &:not(:last-child) {
            border-right: 1px solid var(--tertiary-accent);
        }

        &_danger {
            color: var(--text-error);
        }

        &_success {
            color: var(--text-success);
        }
    }
}
</style>
